import * as z from 'zod'
import { toTypedSchema } from '@vee-validate/zod'

export const rolesRightsSchema = z.object({
  role_type: z.string().min(1, 'Role type is required'),
  name: z.string().min(1, 'Role name is required'),
  can_impersonate: z.boolean().default(false),
  permissions: z.array(z.string()).min(1, 'At least one permission must be selected')
})

export type RolesRightsFormValues = z.infer<typeof rolesRightsSchema>

export const rolesRightsTypedSchema = toTypedSchema(rolesRightsSchema)
